import React, {useState} from "react";
import {Button, Input, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import IconLabel from "../../../shared/components/IconLabel";
import {CheckIcon, CopyIcon, XIcon} from "../../../shared/components/icons";

/**
 * Shows the Pix code for copying by hand, for when the browser wouldn't let
 * us put it on the clipboard.
 *
 * @param {{payload: string, onClose: () => void, message?: string}} props `message` replaces the
 * provider's wording (the customer's page asks for something else)
 */
const PixCodeModal = ({
    payload,
    onClose,
    message = "Não foi possível copiar automaticamente. Copie o código abaixo e envie ao cliente.",
}) => {
    const [copied, setCopied] = useState(false);

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(payload);
            setCopied(true);
        } catch {
            // Still blocked: the text is selected, so Cmd/Ctrl+C works.
        }
    };

    return (
        <Modal isOpen toggle={onClose} fade={false} centered>
            <ModalHeader toggle={onClose}>Código Pix</ModalHeader>
            <ModalBody>
                <p>{message}</p>
                <Input
                    type="textarea"
                    rows={5}
                    readOnly
                    aria-label="Código Pix Copia e Cola"
                    value={payload}
                    onFocus={(event) => event.target.select()}
                    autoFocus
                />
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" outline onClick={onClose}>
                    <IconLabel icon={<XIcon />}>Fechar</IconLabel>
                </Button>
                <Button color="primary" onClick={copy}>
                    {copied ? (
                        <IconLabel icon={<CheckIcon />}>Copiado!</IconLabel>
                    ) : (
                        <IconLabel icon={<CopyIcon />}>Copiar</IconLabel>
                    )}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default PixCodeModal;
